import { useTranslation } from 'react-i18next'

import { EntityArchivedIcon } from '../../Entity'
import { ICON_COLOR, ICON_HEIGHT_16, IconWithTooltip } from '../../Icon'

import * as styles from './RequestProfileHeaderOwnerIcons.module.css'

import Archive2Icon from '../../../icons/archive-2.svg'
import OpenEyeIcon from '../../../icons/open-eye.svg'

function RequestProfileHeaderOwnerIcons({
  isArchived,
  showVisibilityIcon,
  onIconMouseEnter,
  onIconMouseLeave,
}) {
  const { t } = useTranslation()

  return showVisibilityIcon || isArchived ? (
    <div
      className={styles.icons}
      onMouseEnter={onIconMouseEnter}
      onMouseLeave={onIconMouseLeave}
    >
      {showVisibilityIcon ? (
        <IconWithTooltip
          Icon={OpenEyeIcon}
          color={ICON_COLOR.SecondaryTextColor}
          svgSize={ICON_HEIGHT_16}
          tooltip={t('RequestProfile.HeaderOwnerVisibilityIconTooltipKey')}
        />
      ) : null}
      {isArchived ? <EntityArchivedIcon Icon={Archive2Icon} /> : null}
    </div>
  ) : null
}

export default RequestProfileHeaderOwnerIcons
